import { render, staticRenderFns } from "./GoinView.vue?vue&type=template&id=252c064e&scoped=true"
import script from "./GoinView.vue?vue&type=script&lang=js"
export * from "./GoinView.vue?vue&type=script&lang=js"
import style0 from "../assets/fazhan.css?vue&type=style&index=0&id=252c064e&prod&scoped=true&lang=css&external"
import style1 from "./GoinView.vue?vue&type=style&index=1&id=252c064e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252c064e",
  null
  
)

export default component.exports